import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

export default <FunctionalComponentOptions>{
    name: 'WokButton',

    functional: true,

    props: {
        icon: {
            type: String,
            default: undefined
        },
        iconPosition: {
            type: String,
            default: 'right',
            validator: (v: string) => v == '' || /(right|left)/.test(v)
        },
        kind: {
            type: String,
            default: 'primary',
            validator: (v: string) => v == '' || /(primary|secondary|tertiary|danger|ghost|tab)/.test(v)
        },
        size: {
            type: String,
            default: 'default',
            validator: (v: string) => v == '' || /(default|field|small)/.test(v)
        },
        variant: {
            type: String,
            default: undefined
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            default: undefined
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            appropriateTag(ctx), {
                class: [buttonClasses(ctx), ctx.data.staticClass],
                attrs: { 
                    type: 'button',
                    title: ctx.props.tooltip, 
                    disabled: ctx.props.disabled || ctx.props.isLoading, 
                    ...ctx.data.attrs 
                },
                on: ctx.listeners
            }, [
                ctx.slots().default && h('span', { class: 'wok--button__label' }, [
                    ctx.slots().default
                ]),
                appropriateIcon(ctx) && h('i', { class: iconClasses(ctx) }, [
                    h(appropriateIcon(ctx))
                ])
            ]
        )
    }
}

function appropriateTag(ctx: RenderContext) {
    if (ctx.data.attrs && ctx.data.attrs.to) {
        return 'router-link';
    }
    if (ctx.data.attrs && ctx.data.attrs.href) {
        return 'a';
    }
    return 'button';
}

function appropriateIcon(ctx: RenderContext) {
    if (ctx.props.isLoading) {
        return 'wok-icon-progress-16';
    }
    if (ctx.props.icon) {
        return ctx.props.icon;
    }
    return undefined;
}

function buttonClasses(ctx: RenderContext) {
    let classes = [
        'wok--button body-short-01', 
        `wok--button--${ctx.props.kind.toLowerCase()}`,
        `wok--button--${ctx.props.size.toLowerCase()}`,
        `wok--button--icon-${ctx.props.iconPosition.toLowerCase()}`
    ];

    if (ctx.props.isLoading) {
        classes.push('wok--button-is-loading');
    }

    if (ctx.props.variant) {
        classes.push(`wok--button--${ctx.props.variant}`);
    }

    if (!ctx.slots().default) {
        classes.push('wok--button--icon-only');
    }

    return classes;
}

function iconClasses(ctx: RenderContext) {
    return {
        'wok--button__icon': true,
        'wok--icon--is-spinning': ctx.props.isLoading
    }
}